// extracted by mini-css-extract-plugin
module.exports = {"container":"fachgebiete-module--container--we6WG","fieldContainer":"fachgebiete-module--fieldContainer--2_6Kf","field":"fachgebiete-module--field--awK5O"};